import { z } from 'zod';

import { PropertyId } from '../BrandedIds';
import { AppraisalMethod, AppraisalType } from '../loan/Appraisal';
import { zodBrandedUuid, zodDateOrString } from '../utils';
import { NonNegativeMonetaryValue } from '../validations/fields';
import { BaseLoanEvent } from './BaseLoanEvent';

export const AddAppraisalEvent = BaseLoanEvent.extend({
  type: z.literal('addAppraisal'),
  propertyId: zodBrandedUuid<PropertyId>(),
  amount: NonNegativeMonetaryValue,
  date: zodDateOrString,
  appraisalType: AppraisalType,
  appraisalMethod: AppraisalMethod,
  orderId: z.string().optional(),
  isOriginal: z.boolean(),
});

export type AddAppraisalEvent = z.infer<typeof AddAppraisalEvent>;
